var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47136 2.86195C8.73171 3.1223 8.73171 3.54441 8.47136 3.80476L4.2761 8.00002L8.47136 12.1953C8.73171 12.4556 8.73171 12.8777 8.47136 13.1381C8.21101 13.3984 7.7889 13.3984 7.52855 13.1381L2.86189 8.47142C2.60154 8.21108 2.60154 7.78896 2.86189 7.52862L7.52855 2.86195C7.7889 2.6016 8.21101 2.6016 8.47136 2.86195Z",
    fill: "#1F2937"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66663 8.00002C2.66663 7.63183 2.9651 7.33335 3.33329 7.33335H12.6666C13.0348 7.33335 13.3333 7.63183 13.3333 8.00002C13.3333 8.36821 13.0348 8.66669 12.6666 8.66669H3.33329C2.9651 8.66669 2.66663 8.36821 2.66663 8.00002Z",
    fill: "#1F2937"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.dc2eca89b6a58f556e467a2660abf3f0.svg";
export { ForwardRef as ReactComponent };